/**
 * CSS Custom Properties
 *
 * These properties can be overridden using the component's tag as selector.
 *
 * @prop --calcite-shell-tip-spacing: The left and right spacing of the `calcite-tip-manager` when slotted in the component.
 */

:host {
  @extend %component-host;
  @apply absolute
    inset-0
    flex
    h-full
    w-full
    flex-col
    overflow-hidden;
  --calcite-shell-tip-spacing: 26vw;
}

.main {
  @apply relative
    flex
    h-full
    w-full
    flex-auto
    flex-row
    justify-between
    overflow-hidden;
}

.content,
.content--non-interactive {
  @apply flex
    h-full
    w-full
    flex-col
    flex-nowrap;
}

.content {
  @apply overflow-auto;
}

.content ::slotted(calcite-shell-center-row),
.content ::slotted(calcite-panel),
.content ::slotted(calcite-flow) {
  @apply flex-auto self-stretch;
  max-block-size: unset;
}

.content--behind {
  @apply absolute
    inset-0
    border-0;
  z-index: calc(theme("zIndex.default") - 1);
  display: initial;
}

.content--non-interactive {
  @apply pointer-events-none;
}

::slotted(calcite-shell-center-row) {
  inline-size: unset;
}

::slotted(.header .heading) {
  @apply text-n2-wrap font-normal;
}

slot[name="panel-end"]::slotted(calcite-shell-panel) {
  margin-inline-start: auto;
}

::slotted(calcite-panel),
::slotted(calcite-flow) {
  @apply border-color-3
  border
  border-l-0
  border-r-0
  border-solid;
}

slot[name="center-row"]::slotted(calcite-shell-center-row:not([detached])),
slot[name="panel-top"]::slotted(calcite-shell-center-row:not([detached])),
slot[name="panel-bottom"]::slotted(calcite-shell-center-row:not([detached])) {
  @apply border-color-3 border-l border-r;
}

.center-content {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  block-size: 100%;
  inline-size: 100%;
  min-inline-size: 0;
}

::slotted(calcite-shell-center-row) {
  flex: none;
  align-self: stretch;
}

::slotted(calcite-tip-manager) {
  @apply shadow-2
  animate-in-up
  absolute
  box-border
  rounded
  z-toast;
  inset-block-end: theme("spacing.2");
  inset-inline: var(--calcite-shell-tip-spacing);
}

slot[name="center-row"]::slotted(calcite-shell-center-row),
slot[name="panel-bottom"]::slotted(calcite-shell-center-row) {
  margin-block-start: auto;
}

slot[name="panel-top"]::slotted(calcite-shell-center-row) {
  margin-block-end: auto;
}

// positioning logic for expected slotted components
.position-wrapper {
  position: absolute;
  pointer-events: none;
  inset: 0;
}

@include base-component();
